import { useEffect, useState } from "react";
import AdminLayout from "../../../layouts/AdminLayout";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader";
import { updateSpeakerImageData, updateWebinarData } from "../../../redux/features/coach/actions/authAction";
import { coachPaths } from "../../../routes/coach";

const UpdateCoachWebinar = () => {
  const user = { name: "Webinar", role: "coach" };
  const { isLoading } = useSelector((state) => state.coach.auth);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [speakerImages, setSpeakerImages] = useState([""]);
  const [updateImages, setUpdateImages] = useState([""]);

  const [speakerDetails, setSpeakerDetails] = useState([{
    heading: "Meet Nellie Padilla",
    body: "Founder Coach | Startup Strategist | Growth Guide",
    image: ""
  }]);
  const [speakerDetails2, setSpeakerDetails2] = useState([{
    heading: "Meet Nellie Padilla",
    body: "Founder Coach | Startup Strategist | Growth Guide",
    image: ""
  }]);

  const [addSpeakerDetails, setAddSpeakerDetails] = useState([]);

  const [templateData, setTemplateData] = useState({
    section1: {
      heading: state?.data?.section_1?.title ?? "",
      body: state?.data?.section_1?.description ?? "",
    },
    section2: {
      heading: state?.data?.section_2?.title ?? "",
      body: state?.data?.section_2?.description ?? "",
      subHeading1: state?.data?.section_2?.cards[0]?.title ?? "",
      subHeading2: state?.data?.section_2?.cards[1]?.title ?? "",
      subHeading3: state?.data?.section_2?.cards[2]?.title ?? "",
      subHeading4: state?.data?.section_2?.cards[3]?.title ?? "",
      subBody1: state?.data?.section_2?.cards[0]?.description ?? "",
      subBody2: state?.data?.section_2?.cards[1]?.description ?? "",
      subBody3: state?.data?.section_2?.cards[2]?.description ?? "",
      subBody4: state?.data?.section_2?.cards[3]?.description ?? "",
    },
    section3: {
      heading: state?.data?.speakers[0]?.name || "Meet Nellie Padilla",
      body: state?.data?.speakers[0]?.role || "Founder Coach | Startup Strategist | Growth Guide",
      description: state?.data?.speakers[0]?.sub_role || "Helping early-stage entrepreneurs turn ideas into launch-ready businesses with clarity, structure, and confidence. Nellie partners with solopreneurs and small teams to bring their ideas to life through strategic coaching, mindset support, and real-world launch tools."
    },
    section4: {
      heading: state?.data?.section_4?.title ?? "",
      title: state?.data?.section_4?.description ?? "",
      body1: state?.data?.section_4?.cards[0]?.description ?? "",
      body2: state?.data?.section_4?.cards[1]?.description ?? "",
      body3: state?.data?.section_4?.cards[2]?.description ?? ""
    },
    section5: {
      heading: state?.data?.section_5?.title ?? "",
      body: state?.data?.section_5?.description ?? "",
      date: state?.data?.section_5?.cards[0]?.title ?? "",
      time: state?.data?.section_5?.cards[0]?.text_1 ?? "",
      duration: state?.data?.section_5?.cards[0]?.text_2 ?? "",
      platform: state?.data?.section_5?.cards[1]?.title ?? "",
      link: state?.data?.section_5?.cards[1]?.text_1 ?? "",
      access: state?.data?.section_5?.cards[1]?.text_2 ?? "",
      body1: state?.data?.section_5?.cards[2]?.title ?? "",
    },
    section6: {
      faqs: state?.data?.section_6
    },
  });

  useEffect(() => {
    if (state?.data?.speakers?.length != 0) {
      let img = [];
      let details = [];
      let details2 = [];
      state?.data?.speakers?.map((item) => {
        img.push(item)
        details.push({
          heading: item?.name ?? "Meet Nellie Padilla",
          body: item?.role ?? "Founder Coach | Startup Strategist | Growth Guide",
          image: item?.image ?? ""
        })
        details2?.push({
          heading: item?.name ?? "Meet Nellie Padilla",
          body: item?.role ?? "Founder Coach | Startup Strategist | Growth Guide",
          image: item?.image?.split('.com/')[1] ?? ""
        })
      });
      setSpeakerDetails2(details);
      setSpeakerDetails(details);
      setSpeakerImages(img);
    };
  }, []);

  useEffect(() => {
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // YYYY-MM-DD
    const formattedTime = now.toTimeString().split(":").slice(0, 2).join(":"); // HH:MM
    setTemplateData((prev) => ({
      ...prev,
      section5: {
        ...prev.section5,
        date: formattedDate,
        time: formattedTime,
      },
    }));
  }, []);

  const handleChangeValue = (e, field, data) => {
    if (field == "section5" && data == "date") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else if (field == "section5" && data == "time") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e.target.innerText,
        },
      }));
    }
  };

  const handleAddFaq = () => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: [
          ...prevData.section6.faqs,
          { question: "Enter Question", answer: "Enter Answer" },
        ],
      },
    }));
  };

  const handleDeleteFaq = (index) => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: prevData.section6.faqs.filter((_, i) => i !== index),
      },
    }));
  };

  // const handleSubmitForm = () => {
  //   const hasEmptyValue = Object.entries(templateData).some(([key, section]) => {
  //     if (key === "section6") {
  //       return section.faqs.some(
  //         (faq) => faq.question.trim() === "" || faq.answer.trim() === ""
  //       );
  //     } else {
  //       return Object.values(section).some(
  //         (value) => typeof value === "string" && value.trim() === ""
  //       );
  //     }
  //   });
  //   if (hasEmptyValue) {
  //     toast.error("Please fill out all fields before submitting.");
  //     return;
  //   } else {
  //     if (speakerDetails?.length != 0 || addSpeakerDetails?.length != 0) {
  //       const totalSpeakers = state?.data?.speakers?.length || 0;
  //       const allImages = [
  //         ...(addSpeakerDetails || []),
  //         ...(speakerDetails || [])
  //       ];
  //       const validImagesCount = allImages.filter((img) => img?.image && img?.image !== "").length;
  //       if (totalSpeakers < 2 && validImagesCount < 1) {
  //         toast.error("Please add at least 1 speaker image");
  //         return;
  //       }
  //       if (totalSpeakers >= 2 && validImagesCount < 2) {
  //         toast.error("Please add at least 2 speaker images");
  //         return;
  //       }
  //       let data = {}
  //       const { date, time } = templateData.section5;
  //       if (!date || !time) return "";
  //       const localDateTime = new Date(`${date}T${time}`);
  //       const utcDateTime = new Date(localDateTime.getTime() - localDateTime.getTimezoneOffset() * 60000)
  //         .toISOString();
  //       const localDate = templateData?.section5?.date;
  //       const localTime = templateData?.section5?.time;
  //       let utcDate = "";
  //       if (localDate) {
  //         const local = new Date(localDate);
  //         utcDate = new Date(local.getTime() - local.getTimezoneOffset() * 60000)
  //           .toISOString()
  //           .split("T")[0];
  //       };
  //       let utcTime = "";
  //       if (localTime) {
  //         const [hours, minutes] = localTime.split(":");
  //         const local = new Date();
  //         local.setHours(hours, minutes, 0, 0);
  //         const utc = new Date(local.getTime() - local.getTimezoneOffset() * 60000);
  //         utcTime = utc.toISOString().split("T")[1].slice(0, 5); // get only HH:MM
  //       }
  //       data = {
  //         section_1: {
  //           title: templateData?.section1?.heading,
  //           description: templateData?.section1?.body
  //         },
  //         section_2: {
  //           title: templateData?.section2?.heading,
  //           description: templateData?.section2?.body,
  //           cards: [
  //             {
  //               title: templateData?.section2?.subHeading1,
  //               description: templateData?.section2?.subBody1
  //             },
  //             {
  //               title: templateData?.section2?.subHeading2,
  //               description: templateData?.section2?.subBody2
  //             }, {
  //               title: templateData?.section2?.subHeading3,
  //               description: templateData?.section2?.subBody3
  //             }, {
  //               title: templateData?.section2?.subHeading4,
  //               description: templateData?.section2?.subBody4
  //             },
  //           ]
  //         },
  //         section_4: {
  //           title: templateData?.section4?.heading,
  //           description: templateData?.section4?.title,
  //           cards: [
  //             {
  //               title: "Live Strategy Workshop",
  //               description: templateData?.section4?.body1
  //             },
  //             {
  //               title: "Action-Ready Tools",
  //               description: templateData?.section4?.body2
  //             },
  //             {
  //               title: "Real-Time Support",
  //               description: templateData?.section4?.body3
  //             }
  //           ]
  //         },
  //         section_5: {
  //           title: templateData?.section5?.heading,
  //           description: templateData?.section5?.body,
  //           cards: [
  //             {
  //               title: utcDate,
  //               text_1: utcTime,
  //               text_2: templateData?.section5?.duration
  //             },
  //             {
  //               title: templateData?.section5?.platform,
  //               text_1: templateData?.section5?.link,
  //               text_2: templateData?.section5?.access
  //             },
  //             {
  //               title: templateData?.section5?.body1
  //             }
  //           ],
  //         },
  //         section_6: templateData?.section6?.faqs,
  //         schedule_date: utcDateTime,
  //         webinar_id: state?.data?.webinar_id
  //       };
  //       const callback = (response) => {
  //         const callback1 = (response) => {
  //           navigate(coachPaths?.Event);
  //         };
  //         let speakerData = [];
  //         if (state?.data?.speakers?.length >= 2) {
  //           let data12 = [];
  //           speakerDetails2?.map((item) => (
  //             data12?.push({
  //               webinar_id: response?.data?.webinar?.webinar_id,
  //               name: item?.heading,
  //               role: item?.body,
  //                              image: item?.image?.split('.com/')[1]
  //             })
  //           ))
  //           addSpeakerDetails?.map((item) => {
  //             data12?.push({
  //               webinar_id: response?.data?.webinar?.webinar_id,
  //               name: item?.heading,
  //               role: item?.body,
  //             })
  //           })
  //           speakerData = data12;
  //         } else {
  //           speakerData = [{
  //             webinar_id: response?.data?.webinar?.webinar_id,
  //             name: templateData?.section3?.heading,
  //             role: templateData?.section3?.body,
  //             image: updateImages?.length != 0 && updateImages[0] != "" ? speakerImages?.split('.com/')[1] : null,
  //             sub_role: templateData?.section3?.description,
  //           }];
  //         };
  //         const formData = new FormData();
  //         addSpeakerDetails?.length != 0 && addSpeakerDetails?.map((item) => {
  //           formData.append('file', item?.image)
  //         })
  //         updateImages?.length != 0 && updateImages?.map((item) => (
  //           item != "" &&
  //           formData.append('file', item)
  //         ))
  //         formData.append('speakers', JSON.stringify(speakerData));
  //         dispatch(updateSpeakerImageData({ payload: formData, callback: callback1 }))
  //       };
  //       dispatch(updateWebinarData({ payload: data, callback }));
  //     } else {
  //       toast.error("Please Select the sepeker Image");
  //     }
  //   };
  // };

  const handleSubmitForm = () => {
    const hasEmptyValue = Object.entries(templateData).some(([key, section]) => {
      if (key === "section6") {
        return section.faqs.some(
          (faq) => faq.question.trim() === "" || faq.answer.trim() === ""
        );
      } else {
        return Object.values(section).some(
          (value) => typeof value === "string" && value.trim() === ""
        );
      }
    });

    if (hasEmptyValue) {
      toast.error("Please fill out all fields before submitting.");
      return;
    } else {
      if (speakerDetails?.length !== 0 || addSpeakerDetails?.length !== 0) {
        const totalSpeakers = state?.data?.speakers?.length || 0;
        const allImages = [
          ...(addSpeakerDetails || []),
          ...(speakerDetails || []),
        ];
        const validImagesCount = allImages.filter(
          (img) => img?.image && img?.image !== ""
        ).length;

        if (totalSpeakers < 2 && validImagesCount < 1) {
          toast.error("Please add at least 1 speaker image");
          return;
        }
        if (totalSpeakers >= 2 && validImagesCount < 2) {
          toast.error("Please add at least 2 speaker images");
          return;
        }

        let data = {};
        const { date, time } = templateData.section5;
        if (!date || !time) return "";

        const localDateTime = new Date(`${date}T${time}`);
        const utcDateTime = new Date(
          localDateTime.getTime() - localDateTime.getTimezoneOffset() * 60000
        ).toISOString();

        const localDate = templateData?.section5?.date;
        const localTime = templateData?.section5?.time;

        let utcDate = "";
        if (localDate) {
          const local = new Date(localDate);
          utcDate = new Date(local.getTime() - local.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0];
        }

        let utcTime = "";
        if (localTime) {
          const [hours, minutes] = localTime.split(":");
          const local = new Date();
          local.setHours(hours, minutes, 0, 0);
          const utc = new Date(local.getTime() - local.getTimezoneOffset() * 60000);
          utcTime = utc.toISOString().split("T")[1].slice(0, 5);
        }

        data = {
          section_1: {
            title: templateData?.section1?.heading,
            description: templateData?.section1?.body,
          },
          section_2: {
            title: templateData?.section2?.heading,
            description: templateData?.section2?.body,
            cards: [
              {
                title: templateData?.section2?.subHeading1,
                description: templateData?.section2?.subBody1,
              },
              {
                title: templateData?.section2?.subHeading2,
                description: templateData?.section2?.subBody2,
              },
              {
                title: templateData?.section2?.subHeading3,
                description: templateData?.section2?.subBody3,
              },
              {
                title: templateData?.section2?.subHeading4,
                description: templateData?.section2?.subBody4,
              },
            ],
          },
          section_4: {
            title: templateData?.section4?.heading,
            description: templateData?.section4?.title,
            cards: [
              {
                title: "Live Strategy Workshop",
                description: templateData?.section4?.body1,
              },
              {
                title: "Action-Ready Tools",
                description: templateData?.section4?.body2,
              },
              {
                title: "Real-Time Support",
                description: templateData?.section4?.body3,
              },
            ],
          },
          section_5: {
            title: templateData?.section5?.heading,
            description: templateData?.section5?.body,
            cards: [
              {
                title: utcDate,
                text_1: utcTime,
                text_2: templateData?.section5?.duration,
              },
              {
                title: templateData?.section5?.platform,
                text_1: templateData?.section5?.link,
                text_2: templateData?.section5?.access,
              },
              {
                title: templateData?.section5?.body1,
              },
            ],
          },
          section_6: templateData?.section6?.faqs,
          schedule_date: utcDateTime,
          webinar_id: state?.data?.webinar_id,
        };

        const callback = (response) => {
          const callback1 = (response) => {
            navigate(coachPaths?.Event);
          };

          let speakerData = [];
          const formData = new FormData();

          // 🔹 Multi-speaker case
          if (state?.data?.speakers?.length >= 2) {
            let data12 = [];

            speakerDetails2?.map((item) => {
              data12.push({
                webinar_id: response?.data?.webinar?.webinar_id,
                name: item?.heading,
                role: item?.body,
                image: item?.image
                  ? item?.image?.includes(".com/")
                    ? item?.image?.split(".com/")[1]
                    : item?.image
                  : null,
              });
            });

            addSpeakerDetails?.map((item) => {
              data12.push({
                webinar_id: response?.data?.webinar?.webinar_id,
                name: item?.heading,
                role: item?.body,
                image: null,
              });
            });

            speakerData = data12;
          }
          // 🔹 Single-speaker case
          else {
            speakerData = [
              {
                webinar_id: response?.data?.webinar?.webinar_id,
                name: templateData?.section3?.heading,
                role: templateData?.section3?.body,
                image:
                  updateImages?.length !== 0 && updateImages[0] !== ""
                    ? null // file uploaded separately
                    : speakerImages?.length !== 0
                      ? speakerImages[0]?.image?.split(".com/")[1]
                      : null,
                sub_role: templateData?.section3?.description,
              },
            ];
          }

          // 🔹 Append new speaker images
          if (addSpeakerDetails?.length !== 0) {
            addSpeakerDetails.forEach((item) => {
              if (item?.image) formData.append("file", item?.image);
            });
          }

          // 🔹 Append updated single speaker image
          if (updateImages?.length !== 0 && updateImages[0] !== "") {
            formData.append("file", updateImages[0]);
          }

          formData.append("speakers", JSON.stringify(speakerData));
          dispatch(updateSpeakerImageData({ payload: formData, callback: callback1 }));
        };

        dispatch(updateWebinarData({ payload: data, callback }));
      } else {
        toast.error("Please select a speaker image");
      }
    }
  };

  const handleSpeakerImageChange = (e) => {
    let img = [];
    img.push(e.target.files[0])
    setUpdateImages(img);
  };

  const handleAddSpeaker = () => {
    const newSpeaker = {
      heading: "Meet Nellie Padilla",
      body: "Founder Coach | Startup Strategist | Growth Guide",
      image: null
    };
    setAddSpeakerDetails((prev) => [...prev, newSpeaker]);
  };

  const handleRemoveSpeaker = (index) => {
    setAddSpeakerDetails((prev) => prev?.filter((_, i) => i !== index));
  };

  const handleImageManage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    setAddSpeakerDetails((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        image: file
      };
      return updated;
    });
  };

  const handleChangeSpeakerData = (index, field, value) => {
    setAddSpeakerDetails((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };


  const handleChangeSpeakerData2 = (index, field, value) => {
    setSpeakerDetails((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };


  const handleDeleteImage = (index) => {
    setSpeakerDetails((prev) => prev?.filter((_, i) => i !== index));
    setSpeakerImages((prev) => prev?.filter((_, i) => i !== index));
    setSpeakerDetails2((prev) => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = { ...updated[index], image: null };
      };
      return updated;
    });
  };

  if (isLoading) {
    return <Loader />;
  };
  return (
    <AdminLayout>
      <section
        class="ct_workshop_banner_detail ct_px_40 mt-5"
        style={{
          background: "linear-gradient(135deg, #bfc7cb 0%, #bde4f6 100%)",
        }}
      >
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-lg-5 mb-4 mb-lg-0">
              <div class="ct_workshop_right_img">
                <img
                  src="/assets/img/work_detail_banner_left.png"
                  alt=""
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
            <div class="col-lg-7 mb-4 mb-lg-0">
              <div class="ps-lg-5">
                <h2
                  class="ct_fs_50 mb-3"
                  style={{ maxWidth: "596px" }}
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section1", "heading")}
                >
                  {templateData?.section1?.heading ?? ""}
                </h2>
                <p
                  class="mb-0 ct_fs_20"
                  style={{ maxWidth: "565px" }}
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section1", "body")}
                >
                  {templateData?.section1?.body ?? ""}
                </p>
                <div class="mt-4">
                  <a class="ct_yellow_btn px-5 ct_fit_content ct_orange_bg">
                    Reserve Your Spot
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_py_100 ct_px_100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="ct_fs_40 ct_darksky_blue_text text-center mb-3 ct_fw_600"
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section2", "heading")}
              >
                {templateData?.section2?.heading ?? ""}
              </h2>
              <p
                class="mb-0 ct_fs_24 text-center mx-auto"
                style={{ maxWidth: "684px" }}
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section2", "body")}
              >
                {templateData?.section2?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row mt-5 pt-3">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F7F7F7" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section2", "subHeading1")
                    }
                  >
                    {templateData?.section2?.subHeading1}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section2", "subBody1")}
                  >
                    {templateData?.section2?.subBody1}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#EDF6F9" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section2", "subHeading3")
                    }
                  >
                    {templateData?.section2?.subHeading3}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section2", "subBody3")}
                  >
                    {templateData?.section2?.subBody3}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <label class="ct_learn_img">
                <img src="/assets/img/you_will_learn_img.png" alt="" />
              </label>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#ffb80526" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section2", "subHeading2")
                    }
                  >
                    {templateData?.section2?.subHeading2}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section2", "subBody2")}
                  >
                    {templateData?.section2?.subBody2}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4"
                style={{ backgroundColor: "#F5F3EF" }}
              >
                <div>
                  <h4
                    class="ct_fs_24 mb-2"
                    contentEditable="true"
                    onBlur={(e) =>
                      handleChangeValue(e, "section2", "subHeading4")
                    }
                  >
                    {templateData?.section2?.subHeading4}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text"
                    contentEditable="true"
                    onBlur={(e) => handleChangeValue(e, "section2", "subBody4")}
                  >
                    {templateData?.section2?.subBody4}
                  </p>
                </div>
                <div class="ct_mt_20  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {state?.data?.speakers?.length < 2 ? (
        <section
          class="ct_coach_created_bg mt-0 ct_py_100"
          style={{ backgroundColor: "#ffb80533" }}
        >
          <div class="container">
            <div class="row">
              <div class="col-lg-4  mb-4 mb-lg-0">
                <label class="ct_learn_img d-block">
                  <input
                    className="d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleSpeakerImageChange(e)}
                  />
                  <img
                    src={
                      updateImages?.length != 0
                        ? updateImages[0] != ""
                          ? URL.createObjectURL(updateImages[0])
                          : speakerImages?.length != 0
                          ? speakerImages[0]?.image
                          : "/assets/img/meet_nellie_img.png"
                        : speakerImages?.length != 0
                        ? speakerImages[0]?.image
                        : "/assets/img/meet_nellie_img.png"
                    }
                    alt=""
                    style={{ height: "400px" }}
                  />
                </label>
              </div>
              <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                <div class="d-flex align-items-end gap-3 ct_flex_col_575">
                  <div>
                    <h4
                      class="ct_fs_28 ct_orange_text mb-4"
                      contentEditable="true"
                      onBlur={(e) =>
                        handleChangeValue(e, "section3", "heading")
                      }
                    >
                      {templateData?.section3?.heading ?? ""}
                    </h4>
                    <p
                      class="ct_fs_22 mb-0"
                      contentEditable="true"
                      onBlur={(e) => handleChangeValue(e, "section3", "body")}
                    >
                      {templateData?.section3?.body ?? ""}
                    </p>
                    <div class="mt-4">
                      <p
                        class="ct_fs_20 mb-3"
                        style={{ maxWidth: "545px" }}
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section3", "description")
                        }
                      >
                        {templateData?.section3?.description ?? ""}
                      </p>
                    </div>
                    <div class="mt-5">
                      <a class="ct_yellow_btn ct_orange_bg ct_fit_content px-5 mx-auto">
                        View My Profile
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section class=" mt-0 ct_py_100">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="ct_darksky_blue_text text-center ct_fs_44 ct_fw_600 pb-5">
                  Speakers
                </h2>
              </div>
            </div>
            <div className="text-end mb-4">
              <button
                className="ct_yellow_btn py-2 ct_border_radius_10 ms-auto"
                onClick={handleAddSpeaker}
              >
                + Add Speaker
              </button>
            </div>
            <div class="row ct_px_40 justify-content-between">
              {speakerDetails?.map((item, i) => (
                <div class="col-xl-3 col-lg-3 mb-4 ">
                  <div className="position-relative">
                    {state?.data?.speakers?.length > 1 && (
                      <div className="ct_speaker_delete_icon">
                        <i
                          class="fa-solid fa-xmark"
                          onClick={() => handleDeleteImage(i)}
                        ></i>
                      </div>
                    )}
                    <div class="ct_speakers_card">
                      <label class="ct_speaker_img d-block mx-auto">
                        {/* <input className="d-none" accept="image/*" type="file" onChange={(e) => handleImageManage(e, i)} /> */}
                        <img
                          src={
                            speakerImages[i]?.image != ""
                              ? speakerImages[i]?.image
                              : "/assets/img/meet_nellie_img.png"
                          }
                          alt=""
                        />
                      </label>
                      <div class="ct_about_speaker text-center">
                        <h4
                          class="ct_fs_32 ct_fw_600 mb-2 ct_blue_text"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData2(
                              i,
                              "heading",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.heading}
                        </h4>
                        <p
                          class="ct_fs_16"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData2(
                              i,
                              "body",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.body}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {addSpeakerDetails?.map((item, i) => (
                <div class="col-xl-3 col-lg-3 mb-4 ">
                  <div className="position-relative">
                    <div className="ct_speaker_delete_icon">
                      <i
                        class="fa-solid fa-xmark"
                        onClick={() => handleRemoveSpeaker(i)}
                      ></i>
                    </div>
                    <div class="ct_speakers_card">
                      <label class="ct_speaker_img d-block mx-auto">
                        <input
                          className="d-none"
                          accept="image/*"
                          type="file"
                          onChange={(e) => handleImageManage(e, i)}
                        />
                        <img
                          src={
                            addSpeakerDetails[i]?.image != null
                              ? URL.createObjectURL(addSpeakerDetails[i]?.image)
                              : "/assets/img/meet_nellie_img.png"
                          }
                          alt=""
                        />
                      </label>
                      <div class="ct_about_speaker text-center">
                        <h4
                          class="ct_fs_32 ct_fw_600 mb-2 ct_blue_text"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData(
                              i,
                              "heading",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.heading}
                        </h4>
                        <p
                          class="ct_fs_16"
                          contentEditable="true"
                          onBlur={(e) =>
                            handleChangeSpeakerData(
                              i,
                              "body",
                              e.target.innerText
                            )
                          }
                        >
                          {item?.body}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section
        class="ct_looking_for_work_bg ct_mt_100  ct_p_111_y_106 ct_looking_for_work_bg_left"
        style={{ backgroundColor: "#F58220" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Built For Founders. Backed by Experience
            </h4>
            <p class="mb-0 ct_fs_18">
              We’ve designed this workshop to deliver clear direction, not just
              inspiration.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              Reserve Your Spot
            </a>
          </div>
        </div>
      </section>

      <section class="ct_pt_100 ct_pb_100 ct_px_40">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-lg-3 mb-4 mb-lg-0">
              <label class="ct_how_work_img">
                <img src="/assets/img/how_work_678.png" alt="" />
              </label>
            </div>
            <div class="col-lg-9 mb-4 mb-lg-0 ps-lg-5">
              <div class="ct_how_work_content pb-3">
                <h4
                  class="ct_fs_24 ct_yellow_text"
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section4", "heading")}
                >
                  {templateData?.section4?.heading ?? ""}
                </h4>
                <h3
                  class="ct_fs_32"
                  contentEditable="true"
                  onBlur={(e) => handleChangeValue(e, "section4", "title")}
                >
                  {templateData?.section4?.title ?? ""}
                </h3>
              </div>
              <div class="row mt-5">
                <div class="col-lg-4">
                  <div class="ct_how_work_card">
                    <img
                      src="/assets/img/ri_find-replace-fill_orange.png"
                      className="ct_w_50_345"
                      alt=""
                    />
                    <div>
                      <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                        Live Strategy Workshop
                      </h4>
                      <p
                        class="mb-0"
                        style={{ maxWidth: "234px" }}
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section4", "body1")
                        }
                      >
                        {templateData?.section4?.body1 ?? ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="ct_how_work_card">
                    <img
                      src="/assets/img/fa6-solid_handshake_orange.png"
                      className="ct_w_50_345"
                      alt=""
                    />
                    <div>
                      <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                        Action-Ready Tools
                      </h4>
                      <p
                        class="mb-0"
                        style={{ maxWidth: "234px" }}
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section4", "body2")
                        }
                      >
                        {templateData?.section4?.body2 ?? ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="ct_how_work_card">
                    <img
                      src="/assets/img/uim_bag_orange.png"
                      alt=""
                      className="ct_w_50_345"
                    />
                    <div>
                      <h4 class="ct_fs_20 mb-3 ct_darksky_blue_text">
                        Real-Time Support
                      </h4>
                      <p
                        class="mb-0"
                        style={{ maxWidth: "234px" }}
                        contentEditable="true"
                        onBlur={(e) =>
                          handleChangeValue(e, "section4", "body3")
                        }
                      >
                        {templateData?.section4?.body3 ?? ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_py_90 ct_light_sky_bg ">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <h2
                class="ct_fs_32 mb-3 ct_fw_600 text-center "
                style={{ color: "#FFB703" }}
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section5", "heading")}
              >
                {templateData?.section5?.heading ?? ""}
              </h2>
              <p
                class="mb-0  text-center ct_fs_20"
                contentEditable="true"
                onBlur={(e) => handleChangeValue(e, "section5", "body")}
              >
                {templateData?.section5?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row ct_pt_60">
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img src="/assets/img/line-md_calendar.png" alt="" />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Date & Time
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Date: </span>
                      <label>
                        <input
                          type="date"
                          className="border-0 form-control"
                          min={new Date().toISOString().split("T")[0]}
                          value={templateData?.section5?.date}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section5",
                              "date"
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Time: </span>
                      <label>
                        <input
                          type="time"
                          className="border-0 form-control"
                          value={templateData?.section5?.time}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section5",
                              "time"
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Duration: </span>
                      <span contentEditable="true">
                        {templateData?.section5?.duration ?? ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img src="/assets/img/tabler_video-filled.png" alt="" />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Location
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Platform: </span>
                      <span contentEditable="true">
                        {" "}
                        {templateData?.section5?.platform ?? ""}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Link: </span>{" "}
                      <span contentEditable="true">
                        {" "}
                        {templateData?.section5?.link ?? ""}{" "}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap">Replay Access: </span>
                      <span contentEditable="true">
                        {" "}
                        {templateData?.section5?.access ?? ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img src="/assets/img/tabler_video-filled.png" alt="" />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      What You’ll Need
                    </h4>
                    <p
                      class="mb-0 ct_fs_18 text-center mx-auto ct_line_h_30"
                      contentEditable="true"
                    >
                      {templateData?.section5?.body1 ?? ""}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="text-center ct_mt_40">
            <button class="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto">
              Reserve Your Spot
            </button>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
              <div class="ct_about_cnt">
                <h2 class="mb-4 ct_fs_32 mb-5 ">Frequently asked questions</h2>
                <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                  <div class="accordion" id="faq_accordionExample">
                    {templateData?.section6?.faqs?.map((item, i) => (
                      <div className="d-flex align-items-center gap-2">
                        <div class="accordion-item ct_flex_1">
                          <h2
                            class="accordion-header"
                            id="faq_one"
                            contentEditable="true"
                          >
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapsefaq_one${i}`}
                              aria-expanded="false"
                              aria-controls={`collapsefaq_one${i}`}
                            >
                              {item?.question != ""
                                ? item?.question
                                : "Enter Question"}
                            </button>
                          </h2>
                          <div
                            id={`collapsefaq_one${i}`}
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p
                                class="ct_fs_20 mb-3 ct_line_h_30"
                                contentEditable="true"
                              >
                                {item?.answer != ""
                                  ? item?.answer
                                  : "Enter Answer"}
                              </p>
                            </div>
                          </div>
                        </div>
                        {templateData?.section6?.faqs?.length > 1 && (
                          <div className="mt-3 ct_cursor_pointer">
                            <i
                              class="fa-solid fa-trash-can text-danger"
                              onClick={() => handleDeleteFaq(i)}
                            ></i>
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="text-end mt-3">
                      <a
                        className="ct_orange_text ct_fw_600"
                        onClick={handleAddFaq}
                      >
                        + Add FAQ
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-4  col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5">
              <label class="ct_about_img">
                <img
                  src="/assets/img/faq_6789.png"
                  class="ct_img_h_617"
                  alt=""
                />
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg ct_mt_100 ct_p_111_y_106"
        style={{ backgroundColor: "#FFB703" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
              Ready to Join Us Live?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "619px" }}>
              Spaces are limited reserve your seat and walk away with clarity,
              strategy, and momentum{" "}
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              View More
            </a>
          </div>
        </div>
      </section>
      <div style={{ height: "100px" }}></div>
      <div
        class="modal fade modal-lg"
        id="ct_waitlist_modal"
        tabindex="-1"
        aria-labelledby="ct_create_eventLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body p-0 pb-5">
              <h4 class=" text-center mb-1 ct_fs_18 ct_darksky_blue_text px-4">
                You’re Almost In
              </h4>
              <p
                class="mb-0 ct_grey_text px-4 ct_fs_14 text-center mx-auto"
                style={{ maxWidth: "320px" }}
              >
                Save your seat in just few clicks. Limited slots available
              </p>

              <form
                action="javascript:void(0)"
                class="mt-4 ct_modal_scroll ct_custom_scroll px-4"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <label for="" class="d-block mb-2 ct_fs_14">
                        Name
                      </label>
                      <input
                        type="text"
                        class="form-control ct_input ct_fs_14"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <label for="" class="d-block mb-2 ct_fs_14">
                        Email{" "}
                      </label>
                      <input
                        type="text"
                        class="form-control ct_input ct_fs_14"
                        placeholder="Email "
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <label for="" class="d-block mb-2 ct_fs_14">
                        Timezone{" "}
                      </label>
                      <input
                        type="text"
                        class="form-control ct_input ct_fs_14"
                        placeholder="Timezone "
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <label for="" class="d-block mb-2 ct_fs_14">
                        Notes(Optional){" "}
                      </label>
                      <textarea
                        class="form-control ct_input ct_fs_14 h-auto"
                        rows="4"
                        placeholder="Let the coach know what you will like to focus on....."
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3 justify-content-center pt-2">
                  <button
                    class="ct_yellow_btn px-5 ct_h_44 ct_darksky_btn"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_submit_modal"
                  >
                    Confirm My Spot
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mb-5">
        <button
          className="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
          type="button"
          onClick={handleSubmitForm}
        >
          Submit
        </button>
      </div>
    </AdminLayout>
  );
};

export default UpdateCoachWebinar;
